import { Box, Button, Flex, FormControl, FormErrorMessage, Heading,IconButton, Input, InputGroup, InputRightElement, FormHelperText, Stack } from "@chakra-ui/react";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import bgGradient from '../../assets/img/gradient-bg.svg';
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { resetPassword , logout} from "../../features/authSlice";
import { ToastChakra } from "../../helpers/toast";
import { useDispatch, useSelector } from 'react-redux';

const CambiarPasswordPage = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);


    const initialValues = {
        newPassword: '',
        confirmPassword: '',
    };

    const validationSchema = Yup.object({
        newPassword: Yup.string().required('La nueva contraseña es requerida'),
        confirmPassword: Yup.string()
            .required('Confirma la contraseña')
            .oneOf([Yup.ref('newPassword'), null], 'Las contraseñas deben coincidir')
            .matches(/^(?=.*\d).{6,}$/, 'Debe tener al menos 6 caracteres y un número'),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        setSubmitting(true);
        try {
            const data = {
                id: user?.usuario.id,
                correo: user?.usuario.email,
                newPassword: values.newPassword,
            };
    
            // Espera a que la acción se resuelva
            const action = await dispatch(resetPassword(data));
    
            // Verifica si la acción fue exitosa
            if (action.meta.requestStatus === 'fulfilled') {
                dispatch(logout()); // (opcional si tenés este action)
                
                setTimeout(() => {
                    navigate('/login');
                }, 1000);
            }
            else {
                ToastChakra('CONTRASEÑA NO CAMBIADA', action.payload || 'Error al cambiar la contraseña', 'error', 2500, 'bottom');
            }
        } catch (error) {
            console.error('Error al cambiar la contraseña:', error);
            ToastChakra('CONTRASEÑA NO CAMBIADA', 'Ocurrió un error inesperado', 'error', 2500, 'bottom');
        }
        setSubmitting(false);
    };

    const [showPassword1, setShowPassword1] = useState(false);
    const handleShowClick1 = () => setShowPassword1(!showPassword1);

    const [showPassword2, setShowPassword2] = useState(false);
    const handleShowClick2 = () => setShowPassword2(!showPassword2);

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
        >
            {({ isSubmitting, values }) => (
                <Form>
                    <Flex
                        align="center"
                        justify="center"
                        minHeight="100vh"
                        bgImage={bgGradient}
                        bgSize="cover"
                        bgPosition="center"
                        bgRepeat="no-repeat"
                    >
                        <Box
                            bg="white"
                            _dark={{
                                bg: "gray.800",
                                borderWidth: '1px',
                                borderColor: 'gray.700',
                            }}
                            px={6}
                            py={10}
                            rounded="3xl"
                            shadow="lg"
                            maxW="xl"
                            w="full"
                        >
                            <Stack spacing={6}>
                                <Box textAlign="start" >
                                    <Heading fontSize={'2xl'} fontWeight="black" textAlign={'center'}>Cambiar Contraseña</Heading>
                            
                                </Box>
                                <Stack spacing={3}>
                                  
                                    <Field name="newPassword">
                                        {({ field, form }) => (
                                            <FormControl isInvalid={form.errors.newPassword && form.touched.newPassword}>
                                                <InputGroup>
                                                    <Input
                                                        {...field}
                                                        type={showPassword1 ? "text" : "password"}
                                                        value={values.newPassword}
                                                        _focus={{
                                                            borderColor: 'blue.600',
                                                            boxShadow: 'none',
                                                        }}
                                                        placeholder="Nueva Contraseña"
                                                    />
                                                    <InputRightElement w={'3.5rem'}>
                                                        <IconButton
                                                            h="1.75rem"
                                                            alignSelf={'center'}
                                                            color={'white'}
                                                            bg="blue.600"
                                                            _hover={{ bg: 'blue.700' }}
                                                            onClick={handleShowClick1}
                                                            icon={showPassword1 ? <ViewIcon /> : <ViewOffIcon />}
                                                        />
                                                    </InputRightElement>
                                                </InputGroup>
                                                <ErrorMessage name="newPassword" component={FormErrorMessage} />
                                                <FormHelperText>
                                                    Debe tener al menos 6 caracteres y un número.
                                                </FormHelperText>
                                            </FormControl>
                                        )}
                                    </Field>
                                    <Field name="confirmPassword">
                                        {({ field, form }) => (
                                            <FormControl isInvalid={form.errors.confirmPassword && form.touched.confirmPassword}>
                                                <InputGroup>
                                                    <Input
                                                        {...field}
                                                        type={showPassword2 ? "text" : "password"}
                                                        value={values.confirmPassword}
                                                        _focus={{
                                                            borderColor: 'blue.600',
                                                            boxShadow: 'none',
                                                        }}
                                                        placeholder="Confirmar Contraseña"
                                                    />
                                                    <InputRightElement w={'3.5rem'}>
                                                        <IconButton
                                                            h="1.75rem"
                                                            alignSelf={'center'}
                                                            color={'white'}
                                                            bg="blue.600"
                                                            _hover={{ bg: 'blue.700' }}
                                                            onClick={handleShowClick2}
                                                            icon={showPassword2 ? <ViewIcon /> : <ViewOffIcon />}
                                                        />
                                                    </InputRightElement>
                                                </InputGroup>
                                                <ErrorMessage name="confirmPassword" component={FormErrorMessage} />
                                            </FormControl>
                                        )}
                                    </Field>
                                </Stack>
                                <Button
                                    colorScheme="blue"
                                    _dark={{
                                        bg: 'blue.600',
                                        color: 'white',
                                        _hover: {
                                            bg: 'blue.700',
                                        },
                                    }}
                                    fontSize="md"
                                    fontWeight="bold"
                                    w="full"
                                    borderRadius={'xl'}
                                    type="submit"
                                    isLoading={isSubmitting ? true : false}
                                    disabled={isSubmitting}
                                    loadingText="Modificando su contraseña..."
                                    spinnerPlacement="end"
                                >
                                    Cambiar Contraseña
                                </Button>
                    
                            </Stack>
                        </Box>
                    </Flex>
                </Form>
            )}
        </Formik>
    );
};

export default CambiarPasswordPage;